import { Panel } from "@/components/KpiCard";
import { SmartTable } from "@/components/SmartTable";
import { money } from "@/lib/api";

const Th = ({ children, right }) => <th className={`py-2 pr-3 ${right ? "text-right" : ""}`}>{children}</th>;

export const ThPercuePanel = ({ lignes, total }) => (
  <Panel title="Taxe de séjour (3,5 %) perçue par la plateforme, à remettre" testId="bilan-th-percue-panel">
    {!lignes.length ? (
      <p className="text-sm text-slate-500" data-testid="bilan-th-percue-vide">Aucune taxe de séjour versée par une plateforme cette année.</p>
    ) : (
      <div className="overflow-x-auto">
        <SmartTable id="th-percue" data-export-titre="Taxe séjour perçue" className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wide text-slate-500">
            <Th>Date</Th><Th>Réservation</Th><Th>Plateforme</Th><Th>Voyageur</Th><Th>Logement</Th><Th right>Nuitées</Th><Th right>Taxe perçue</Th>
          </tr></thead>
          <tbody>
            {lignes.map((p) => (
              <tr key={p.code} className="border-t border-slate-100" data-testid={`bilan-th-percue-${p.code}`}>
                <td className="py-2 pr-3 tabular">{p.date}</td><td className="py-2 pr-3 font-mono text-xs">{p.code}</td>
                <td className="py-2 pr-3">{p.plateforme}</td><td className="py-2 pr-3">{p.nom_client || "—"}</td>
                <td className="py-2 pr-3 text-slate-600">{p.logement}</td><td className="py-2 pr-3 text-right tabular">{money(p.loyer)}</td>
                <td className="py-2 text-right tabular font-medium text-amber-700">{money(p.th_percue)}</td>
              </tr>
            ))}
            <tr className="border-t-2 border-slate-300 font-semibold" data-st-fixe="">
              <td className="py-2 pr-3" colSpan={6}>Total à remettre à Revenu Québec</td>
              <td className="py-2 text-right tabular text-amber-700" data-testid="bilan-th-percue-total">{money(total)}</td>
            </tr>
          </tbody>
        </SmartTable>
        <p className="mt-3 text-xs text-slate-500">La plateforme a facturé la taxe sur l'hébergement au voyageur et vous l'a versée avec le paiement : elle doit être remise à Revenu Québec. Saisissez-la dans « Modifier » (champ « Taxe de séjour perçue ») quand la plateforme l'indique.</p>
      </div>
    )}
  </Panel>
);
